import type {
  QueryFunctionContext,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import {
  CAMPAIGN_BLOCKS,
  CAMPAIGN_REBUS_HERO,
  PROMO_CODE,
  PROMO_HERO,
  SEO,
  SLUG,
} from 'lib/queries';
import { client } from 'lib/sanity';
import type { PromotionPage } from 'types/cms/pages/PromotionPage';

type PromotionPageQuery = UseQueryResult & {
  data: PromotionPage;
};

export const PROMOTION_PAGE_KEY = 'promotionPage';

type PromotionPageQueryKey = [string, string];

export const fetchPromotion = async ({
  queryKey,
}: QueryFunctionContext<PromotionPageQueryKey>) => {
  const query = groq`
  *[ _type in['timeline_promotion'] && slug.current == $slug][0] {
    ${SLUG},
    ${SEO},
    title,
    ${PROMO_CODE},
    ${PROMO_HERO},
    ${CAMPAIGN_REBUS_HERO},
    termsAndConditions,
    "blocks": coalesce(template -> blocks[] { ${CAMPAIGN_BLOCKS} }, blocks[]{ ${CAMPAIGN_BLOCKS} })
  }
  `;

  const promotion: PromotionPage = await client.fetch(query, {
    slug: queryKey[1],
  });

  return promotion;
};

export const usePromotion = (slug: string) =>
  useQuery({
    queryKey: [PROMOTION_PAGE_KEY, slug],
    queryFn: fetchPromotion,
  }) as PromotionPageQuery;
